var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-info"},[_c('admin-title',{attrs:{"title":"全域紧急联系人"}}),_c('card',{staticClass:"member-list"},[_c('tp-table',{attrs:{"table-data":_vm.qyMemberContactList,"columns":_vm.columns,"is-page":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }